import { get, isEmpty } from 'lodash';
import { retrieveDataMapper, retrieveObjectMapper } from '../..';

export const transformBasicChild = (
  childClasses = [],
  children = [],
  upcomingClasses = {},
  classes = [],
  centres = {},
  levels = []
) => {
  if (isEmpty(children)) return null;
  return {
    data: (childClasses || []).map(childClass => ({
      child: {
        ...retrieveDataMapper(children, childClass?.fk_child, [
          'ID:id',
          'firstname',
          'lastname',
          'date_of_birth',
          'birth_certificate',
          'enrolment_date',
          'first_enrolment_date',
          'image_key',
          'imageKeyPresignedURL:image_key_presigned_url',
        ]),
        upcomingClass: (() => {
          const upcomingClass = get(
            retrieveDataMapper(upcomingClasses, childClass?.fk_child, ['data']),
            'data.0'
          );
          if (!upcomingClass) return null;
          const classObj = retrieveDataMapper(
            classes,
            upcomingClass?.fk_class,
            ['ID:id', 'label', 'fk_centre', 'fk_level']
          );

          return {
            ...retrieveObjectMapper(upcomingClass, ['from']),
            class: classObj
              ? {
                  ...classObj,
                  centre: retrieveDataMapper(
                    centres?.data,
                    classObj?.fkCentre,
                    ['ID:id', 'label']
                  ),
                  level: retrieveDataMapper(levels, classObj?.fkLevel, [
                    'label',
                  ]),
                }
              : null,
          };
        })(),
      },
    })),
  };
};

export const transformGetAllClassInfo = ({
  response = {},
  levels = {},
  nextLevels = {},
  centres = {},
  childCurrentClasses = {},
  childUpcomingClasses = {},
  classTeachers = [],
  teachers = [],
  children = [],
  childUpcomingClassesByChildIds = {},
  classes = [],
}) => {
  return {
    data: {
      getAllClassInfo: {
        data: (get(response, 'data.data') || []).map(item => ({
          ...retrieveObjectMapper(item, [
            'ID:id',
            'label',
            'description',
            'is_hidden',
            'is_default',
            'profile_photo_key',
            'profilePhotoKeyPresignedURL:profile_photo_key_presigned_url',
            'cover_photo_key',
            'coverPhotoKeyPresignedURL:cover_photo_key_presigned_url',
          ]),
          level: {
            ...retrieveDataMapper(levels, item?.fk_level, [
              'ID:id',
              'code',
              'label',
            ]),
            nextLevel: retrieveDataMapper(nextLevels, item?.fk_level, [
              'ID:id',
              'label',
            ]),
          },
          centre: retrieveDataMapper(
            get(centres, 'data', []),
            item?.fk_centre,
            ['ID:id', 'code', 'label']
          ),
          currentChildClasses: {
            ...retrieveDataMapper(childCurrentClasses, item?.id, [
              'totalCount',
            ]),
            ...transformBasicChild(
              get(childCurrentClasses, `[${item?.id}].data`) || [],
              children,
              childUpcomingClassesByChildIds,
              classes,
              centres,
              levels
            ),
          },
          classTeachers: {
            data: classTeachers
              .filter(teacher => teacher?.fk_class === item?.id)
              .map(classTeacher => ({
                ID: get(classTeacher, 'id'),
                user: retrieveDataMapper(teachers, classTeacher?.fk_teacher, [
                  'ID:id',
                  'firstname',
                  'lastname',
                ]),
              })),
          },
          upcomingChildClasses: {
            ...retrieveDataMapper(childUpcomingClasses, item?.id, [
              'totalCount',
            ]),
            ...transformBasicChild(
              get(childUpcomingClasses, `[${item?.id}].data`) || [],
              children,
              childUpcomingClassesByChildIds,
              classes,
              centres,
              levels
            ),
          },
        })),
        totalCount: get(response, 'data.total_count', 0),
      },
    },
    success: true,
  };
};

export default {
  transformGetAllClassInfo,
};
